(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8499],{

/***/ 40843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(64834),
    isArrayLike = __webpack_require__(55156);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 47379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(95260),
    baseGet = __webpack_require__(5705),
    baseIteratee = __webpack_require__(11340),
    baseMap = __webpack_require__(40843),
    baseSortBy = __webpack_require__(20513),
    baseUnary = __webpack_require__(86626),
    compareMultiple = __webpack_require__(20922),
    identity = __webpack_require__(18594),
    isArray = __webpack_require__(35067);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 20513:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 94739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(12937);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 20922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(94739);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 6188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(36191),
    baseOrderBy = __webpack_require__(47379),
    baseRest = __webpack_require__(98089),
    isIterateeCall = __webpack_require__(42451);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 69752:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-care",
      function () {
        return __webpack_require__(90938);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ loadAppointmentReasons; }
/* harmony export */ });
/* unused harmony export memoizedLoadApptReasonsExportedForTesting */
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56776);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34557);
/* harmony import */ var _utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54428);




function loadAppointmentReasons() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    return memoizedLoadApptReasonsExportedForTesting(practiceId, video, instant).catch(()=>[]);
}
// Exported only for testing. Prod code should call loadAppointmentReasons().
const memoizedLoadApptReasonsExportedForTesting = memoizee__WEBPACK_IMPORTED_MODULE_0___default()(async function() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    const response = await (0,_utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()("/hib/practices/".concat(practiceId, "/apptReasons/v2?").concat(video ? "supportsVideoVisit=true" : "").concat(instant ? "supportsInstantVisit=true" : ""));
    return await response.json();
}, {
    maxAge: _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__/* .MsMap.ONE_MINUTE */ .I.ONE_MINUTE * 20,
    promise: true
});


/***/ }),

/***/ 90938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_get_care; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/_services/monolith/appointmentReasons.ts
var appointmentReasons = __webpack_require__(82858);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(6188);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var src_store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/utils/isReasonDiscoverable.ts + 1 modules
var isReasonDiscoverable = __webpack_require__(79761);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/page-containers/get-care/stylesheets/get-care.module.scss
var get_care_module = __webpack_require__(53259);
var get_care_module_default = /*#__PURE__*/__webpack_require__.n(get_care_module);
;// CONCATENATED MODULE: ./src/page-containers/get-care/index.tsx













const AppointmentReasons = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { reasons  } = (0,src_store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageTitle: i18n.t("Carbon Health Services - Reasons"),
        pageDescription: i18n.t("Carbon Health offers Clinic, Virtual and Video Appointments for a Full Range of Adult & Pediatric Carbon Health Services, including X-Rays, Labs and More."),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((get_care_module_default()).wrap, " ph8 mt26 maxw80 ma"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "mb4",
                    children: i18n.t("Reasons")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "".concat((get_care_module_default()).items, " basic"),
                    children: sortBy_default()(reasons, "name").map((reason)=>reason && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (get_care_module_default()).item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: {
                                    pathname: "".concat(_constants/* v5Pages.getCareRoot */.Td.getCareRoot, "/").concat(reason.slug)
                                },
                                className: "tac db color-default hover-sham",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fs32 cIcon-".concat(reason.iconName || "defaultReasonIcon")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "db fx mt2 lh14 mh1-md",
                                        children: i18n.t(reason.name)
                                    })
                                ]
                            })
                        }, reason.id))
                })
            ]
        })
    });
};
AppointmentReasons.getInitialProps = async (param)=>{
    let { store  } = param;
    if (!store.getState().config.reasons) {
        const reasons = (await (0,appointmentReasons/* loadAppointmentReasons */.J)(practiceIds/* PracticeId.CARBON */.I.CARBON) || []).map((reason)=>({
                id: reason.id,
                slug: reason.slug,
                name: reason.name,
                iconName: reason.iconName,
                description: reason.description,
                specialtyIds: reason.specialtyIds,
                newPatientDuration: reason.newPatientDuration,
                supportsVideoVisit: reason.supportsVideoVisit,
                supportsInstantVisit: reason.supportsInstantVisit,
                practiceApptReasonSpecialties: reason.practiceApptReasonSpecialties,
                code: reason.code
            })).filter((r)=>(0,isReasonDiscoverable/* isReasonDiscoverable */.t)(r));
        store.dispatch(src_store/* actions.setConfig */.Nw.setConfig({
            reasons
        }));
    }
    return {};
};
/* harmony default export */ var get_care = (AppointmentReasons);

;// CONCATENATED MODULE: ./src/pages/get-care/index.ts

/* harmony default export */ var pages_get_care = (get_care);


/***/ }),

/***/ 79761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ isReasonDiscoverable; }
});

;// CONCATENATED MODULE: ./src/constants/reasonCodes.ts
const ReasonCode = {
    CORONAVIRUS_SUSPICION_APPT_REASON_CODE: "VisitType:coronavirusSuspicion",
    FOR_DEV_TESTING_ONLY: "FOR_DEV_TESTING_ONLY"
};
const apptReasonEntityCodesToHide = [
    ReasonCode.CORONAVIRUS_SUSPICION_APPT_REASON_CODE,
    ReasonCode.FOR_DEV_TESTING_ONLY
];

;// CONCATENATED MODULE: ./src/utils/isReasonDiscoverable.ts

const isVisibilityConfigAcceptable = (visibilityConfig)=>!visibilityConfig || !visibilityConfig.providerOnly;
const isValidSortIndex = Number.isInteger;
const isReasonDiscoverable = function(apptReason) {
    let letNullSortIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    try {
        const isNotHiddenByCode = !apptReasonEntityCodesToHide.includes(apptReason.code);
        const hasValidSpecialty = apptReason.practiceApptReasonSpecialties.some((param)=>{
            let { sortIndex , visibilityConfig  } = param;
            return (letNullSortIndex || isValidSortIndex(apptReason.sortIndex) || isValidSortIndex(sortIndex)) && isVisibilityConfigAcceptable(visibilityConfig);
        });
        return hasValidSpecialty && isNotHiddenByCode;
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 53259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"doc":"get-care_doc__4CGhQ","bigger":"get-care_bigger__IQ8XN","desc":"get-care_desc__6Afua","tablink":"get-care_tablink__EN4Td","btn":"get-care_btn__7Zygm","drugs":"get-care_drugs__eJ56g","bar":"get-care_bar__3gCdp","review-box-inner":"get-care_review-box-inner__ehVVk","floating":"get-care_floating__RUxnc","bar2-wrapper":"get-care_bar2-wrapper__naox_","bar2":"get-care_bar2__SSdVt","imgs-wrap":"get-care_imgs-wrap__npEvd","items":"get-care_items__SAdFO","item":"get-care_item__ijqA1","wrap":"get-care_wrap__MlVwR"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,6282,2122,9774,2888,179], function() { return __webpack_exec__(69752); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);